import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { VehicleCard } from "@/components/VehicleCard";
import { usePageSeo } from "@/context/SiteContext";

export default function SoldInventoryPage() {
  usePageSeo("Recently Sold Vehicles", "Vehicles recently sold by SSH Auto Sales in Edmonton, Alberta. Browse our sold archive and current available inventory.");
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/vehicles/sold")
      .then((r) => setVehicles(r.data))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="sold-inventory-page">
      <div className="bg-muted border-b border-border py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight text-foreground">
            Recently Sold
          </h1>
          <p className="text-muted-foreground mt-2">Vehicles that recently found new owners at SSH Auto Sales.</p>
          <div className="flex gap-4 mt-5 text-sm font-bold uppercase tracking-wider">
            <Link to="/inventory" className="text-muted-foreground hover:text-primary pb-1" data-testid="tab-available-link">
              Available
            </Link>
            <span className="text-primary border-b-2 border-primary pb-1" data-testid="tab-sold">Recently Sold</span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {loading ? (
          <div className="flex justify-center py-20" data-testid="sold-loading">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : vehicles.length === 0 ? (
          <div className="border border-dashed border-border rounded-md p-20 text-center" data-testid="sold-empty">
            <p className="font-display text-xl font-bold uppercase text-foreground mb-2">No Recently Sold Vehicles Yet</p>
            <p className="text-sm text-muted-foreground mb-6">Check back soon — or browse our current available inventory.</p>
            <Link to="/inventory" className="btn-themed" data-testid="sold-empty-browse">
              Browse Available Inventory
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sold-grid">
            {vehicles.map((v) => (
              <VehicleCard key={v.id} vehicle={v} sold />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
